/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 12/18/20
 * Time: 1:55 PM
 */
import React from 'react';
import {MDBModal} from "mdbreact";
import QueryString from "query-string";
import JWT_Decode from "jwt-decode";
import TxtLbl from "../../components/Input/Input/TxtLbl";
import {Col} from "reactstrap";
import {Button, Checkbox} from "semantic-ui-react";
import '../VisitorForwardForm/VisitorForward_/VisitorForward_.scss';
import * as util from "../../util/Validator";
import * as common from "../../const/Common/CommonFunc";
import swal from "sweetalert";
import are_you_sure_icon from "../../assets/img/sweet/question.svg";
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import axios from "../../axios/axios_visitortag";
import apiConfig from "../../axios/axios_api_services";

let UPDATE = "UPDATE";
class App extends React.Component {
  state = {access: true, token: null, mvid: 0, email: null, refid: 0,vehicleNumber:'',isTerms:false,isDone:false,type:UPDATE};

  checkQueryString = () => {
    let queryParams = QueryString.parse(window.location.search);
    let queryStringParam = queryParams.bWeu4e;
    let queryStringType = queryParams.vehicle;

    this.setState({type: queryStringType?queryStringType:UPDATE});

    if (queryStringParam) {
      this.decodeToken(queryStringParam)
    } else {
      this.setState({access: false});
    }
  };
  decodeToken = (queryStringParam) => {
    try {
      let decode_token = JWT_Decode(queryStringParam);

      let mvid = decode_token.mvId;
      let email = decode_token.sub;
      let refid = decode_token.refNo;

      if (mvid === undefined || email === undefined || refid === undefined) {
        this.setState({access: false});
      } else {
        this.setState({token: queryStringParam, mvid, email, refid})
      }
    } catch (e) {
      console.log("decodeToken error: ", e);
      this.setState({access: false});
    }
  };

  componentWillMount() {
    this.checkQueryString();
  }
  handleChange = (name) => event => {
    let value = event.target.value;
    value = value.toUpperCase();
    if(util.keyPressVehicleNumberValidation(value)){
      this.setState({[name]: value})
    }
  };

  isValidate = () => {
    let {vehicleNumber,isTerms,email,mvid,refid} = this.state;
    if(!util.vehicleNumberPlateValidation(vehicleNumber.trim())){
      common.notifyMessage("Please enter valid vehicle number format. (AB-1234 or ABC-1234)",0,4);
      return;
    }
    if(!isTerms){
      common.notifyMessage("Please accept the Terms of Service to proceed");
      return
    }
    const obj = {
      "email": email,
      "refid": refid,
      "mvid": mvid,
      "vehicleNumber": vehicleNumber
    };

    swal({
      title: "Are you sure, you want to proceed?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {
      switch (value) {
        case "action":
          this.sendToBackend(obj);
          break;
        default:
          break;
      }
    });
  };
  sendToBackend = (obj) => {
    this.props.spinnerHandler(true);
    const headers = {
      "token": "Bearer " + this.state.token
    };

    axios.patch(apiConfig.VISITOR_VEHICLE_NUMBER_UPDATE, obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({isDone:true,vehicleNumber:'',isTerms:false});
          common.warningAlert(response.data.message, 0)
        } else {
            common.warningAlert(response.data.message, 1)
        }
      })
      .catch(error => {
        if (error.response.status === 403) {
          common.warningAlert(error.response.data.message, 1)
        } else {
          common.warningAlert(`Something went wrong - Code: ${error && error.response.status ? error.response.status: 0}`, 1)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  render() {
    let {vehicleNumber,isTerms,access,isDone,type} = this.state;
    return (
      <div>
        <MDBModal overflowScroll={true} noClickableBodyWithoutBackdrop={false} inline={false} isOpen={true}
                  toggle={() => {
                  }} size="md" className={"reg-form-main-content visitor-change-vehicle-no"}>

          <h4 className={"reg-form-main-topic"}>{`${type === UPDATE ? `Change`:`Add`} Your Vehicle Number`}</h4>
          <div className={"full-width"}>
            <p className={"title"}>{`Please enter your ${type === UPDATE ? `new`:``} vehicle number`}</p>
            <TxtLbl
              placeholder={"AB-1234"}
              value={vehicleNumber}
              onChange={this.handleChange('vehicleNumber')}
            />
            <br/>
            {
              access && !isDone ?
                <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                  <Checkbox style={{cursor: 'pointer'}}
                            label={<label>I accept the <a target="_blank" href={'/vms_privacy_policy'}> Terms of
                              Service </a> | <a target="_blank" href={'https://www.dialog.lk/privacy-policy'}> Privacy
                              Policy</a>.</label>}
                            onChange={() => this.setState({isTerms: !isTerms})}
                            checked={isTerms}
                  />
                  <br/><br/>
                  <Button className="px-5" onClick={this.isValidate}>Submit</Button>
                </Col> : null
            }
          </div>

        </MDBModal>
        {
          !access ?
            <div className={"warning-page"}>
              <i className="fa fa-exclamation-triangle" aria-hidden="true"/> Sorry you can't access this page!
            </div> : null
        }
        {
          this.state.isDone ?
            <div className={"warning-done-page"}>
              {`Vehicle number successfully ${type === UPDATE ? `updated`:`added`}`}
            </div> : null
        }
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data))
  };
};

export default connect(null, mapDispatchToProps)(App);
